import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Building2, Hospital, GraduationCap, TrendingUp } from "lucide-react";

const Applications = () => {
  const applications = [
    {
      icon: Building2,
      title: "出海制造企业",
      description: "支持企业在 ODI审批、招投标、政府批文 等环节实现快速处理与内部流转，提升国际业务效率。"
    },
    {
      icon: Hospital,
      title: "园区 / 商会 / 投促机构",
      description: "批量处理 招商引资企业材料 与 跨境对接文件，助力招商引资与产业服务。"
    },
    {
      icon: GraduationCap,
      title: "律所 / 咨询机构",
      description: "以低成本实现 客户材料初审，有效提升合同签约及合规审查的效率。"
    },
    {
      icon: TrendingUp,
      title: "平台 / 系统集成商",
      description: "作为 PDF翻译与还原插件 无缝嵌入现有系统，增强平台功能，优化用户体验。"
    }
  ];

  return (
    <section id="applications" className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            典型应用场景
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {applications.map((app, index) => (
            <Card key={index} className="text-center border-0 shadow-card hover:shadow-elegant transition-all duration-500 hover:-translate-y-3 hover:scale-105 bg-gradient-to-b from-card to-card/90 group animate-slide-up" style={{ animationDelay: `${index * 0.15}s` }}>
              <CardHeader className="pb-4">
                <div className="w-16 h-16 bg-gradient-to-br from-primary/10 via-primary/5 to-accent/10 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300 shadow-lg group-hover:shadow-glow animate-float" style={{ animationDelay: `${index * 0.5}s` }}>
                  <app.icon className="w-8 h-8 text-primary group-hover:text-primary-light transition-colors duration-300" />
                </div>
                <CardTitle className="text-lg font-semibold group-hover:text-primary transition-colors duration-300">{app.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-muted-foreground leading-relaxed">
                  {app.description}
                </CardDescription>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Applications;